export default {
  entityName: "Country",
  apiEndpoint: "/master/countries",
  permissions: {
    view: "master:view",
    edit: "master:edit",
  },
  columns: [
    { key: "code", label: "Code", sortable: true, class: () => "font-mono font-bold" },
    { key: "name", label: "Country Name", sortable: true },
    { key: "currencyCode", label: "Currency Code", sortable: true },
    { key: "isdCode", label: "ISD Code", sortable: true },
  ],
  fields: [
    { name: "code", label: "Code", type: "text", required: true, uppercase: true, placeholder: "e.g. IN" },
    { name: "name", label: "Country Name", type: "text", required: true, placeholder: "e.g. India" },
    { name: "currencyCode", label: "Currency Code", type: "text", required: true, uppercase: true, placeholder: "e.g. INR" },
    { name: "isdCode", label: "ISD Code", type: "text", required: true, placeholder: "e.g. +91" },
    
    // Advanced properties wrapped in Accordion
    { name: "iso3", label: "ISO 3-letter Code", type: "text", uppercase: true, placeholder: "e.g. IND", advanced: true },
    { name: "continent", label: "Continent", type: "text", default: "Asia", advanced: true },
    { name: "region", label: "Sub-Region Group", type: "text", advanced: true },
    { name: "defaultTimezone", label: "Default Timezone", type: "text", default: "UTC", advanced: true },
    { name: "defaultLanguage", label: "Default Language", type: "text", default: "en", advanced: true },
    { name: "effectiveFrom", label: "Effective From", type: "date", advanced: true },
    { name: "effectiveTo", label: "Effective To", type: "date", advanced: true },
  ],
  filters: [],
  workflow: {
    type: "country_approval",
    enabled: true,
  },
};
